/**
 * Private modules
 */
const {
  accountId,
  accountType,
  createQueryComponent,
  employerId,
  nickname,
  objectId,
  objectIds,
  password,
  reason,
  username,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  createAccountWorker: {
    properties: {
      body: {
        properties: {
          nickname,
          password,
          type: accountType,
          username,
        },
        required: [
          'nickname',
          'password',
          'type',
          'username',
        ],
        type: 'object',
      },
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getAccountWorkers: {
    properties: {
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  recoverAccountWorkers: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  removeAccountWorkers: {
    properties: {
      body: {
        properties: {
          objectIds,
          reason,
        },
        required: [
          'objectIds',
          'reason',
        ],
        type: 'object',
      },
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  updateAccountWorkerById: {
    properties: {
      body: {
        properties: {
          employerId,
        },
        required: ['employerId'],
        type: 'object',
      },
      params: {
        properties: {
          accountId,
          objectId,
        },
        required: [
          'accountId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
